module.exports = "/_next/static/images/BetMGM-a4d7aa37325e707cb685c0a08e89e3fe.svg";